import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { Dialog } from "@material-ui/core";
import styled from '@emotion/styled';


const MyDialog = withStyles((props) => ({
    paper: {
        padding: props => props.padding ? props.padding : "48px",
        width: props => props.width ? props.width : "",
        minWidth: "550px",
        maxWidth: "1200px",
      }
  }))(Dialog);

const Modal = ({isShowing, close, children, padding, width}) => {
    return (
        <MyDialog
            className="modal"
            open={isShowing}
            onClick={(e) => e.stopPropagation()}
            onClose={close}
            padding={padding}
            width={width}
            >
            {children}
        </MyDialog>
    )
}

const MyDiv = styled.div`
    width: 100%;
    height: ${props => props.height ? props.height : "100%"};
    display: flex;
    align-items: center;
    justify-content: ${props => props.justify ? props.justify : "flex-end"};
    margin-top: ${props => props.marginTop ? props.marginTop : ""};
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : ""};
    & > *:not(:last-child) {
        margin-right: 24px;
    }
`;

export const ButtonWrapper = (props) => {
    const { justify, marginTop, marginBottom, height } = props;
    return (
       <MyDiv justify={justify} marginTop={marginTop} marginBottom={marginBottom} height={height}>
            {props.children}
       </MyDiv> 
    )
}

export const ModalTitle = (props) => {
    return (
        <h2 className="h3b modal_title">{props.children}</h2>
    )
}

const ModalSubTitleWrapper = styled.h3`
    margin-bottom: 16px;
    :not(:first-of-type) {
        margin-top: 22px;
    }
`;

export const ModalSubTitle = (props) => {
    return (
        <ModalSubTitleWrapper className="h4b modal_subtitle">{props.children}</ModalSubTitleWrapper>
    )
}

const TextWrapper = styled('p')`
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : "16px"};
`;

export const ModalText = (props) => {
    return (
        <TextWrapper marginBottom={props.marginBottom} className="hxr">{props.children}</TextWrapper>
    )
}

const CheckListWrapper = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 16px 0 16px;
    > *:not(:last-child) {
        margin-bottom: 8px;
    }
    }
`;

export const CheckList = (props) => {
    return (
        <CheckListWrapper>
            {props.children}
        </CheckListWrapper>
    )
}

const CheckItemWrapper = styled('div')`
    width: 100%;
    display: flex;
    align-items: center;
    > img {
        margin-right: 8px;
    }
`;

export const CheckItem = (props) => {
    const { isJSX } = props;
    return (
        <CheckItemWrapper>
            <img src={`/images/icons/check.svg`} alt="check" />
            {!isJSX && <p className="hxr">{props.children}</p>}
            {isJSX && props.children}
        </CheckItemWrapper>
    )
}

export default Modal
